import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: 'DurationHumanize'
})
export class DurationHumanize implements PipeTransform {
  public formatedDate: any;

  transform(date, arg) {
    let x = date;
    const seconds = x % 60;
    x /= 60;
    const minutes = x % 60;
    x /= 60;
    const hours = x % 24;
    x /= 24;
    const days = x;
    let calcDate = '';
    if (days >= 1) {
      calcDate = Math.round(days) + ' days ';
    }
    if (hours >= 1) {
      calcDate = calcDate + Math.round(hours) + ' hrs ';
    }
    if (minutes >= 1) {
      calcDate = calcDate + Math.round(minutes) + ' min ';
    }
    if (seconds >= 1) {
      calcDate = calcDate + Math.round(seconds) + ' sec ';
    }
    return calcDate;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/duration-humanize.pipe.ts